import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { ROUTES, POST_LOGOUT_REDIRECT_KEY } from '../../lib/constants'

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  // Decide the redirect target the moment `user` first goes null, and latch
  // it in state so later re-renders (there's at least one more after this,
  // in practice) can't re-read sessionStorage and find the flag already
  // cleared. This is React's documented "adjust state during render"
  // pattern — safe under StrictMode's double-render because the read here
  // is pure (no sessionStorage mutation), unlike putting it in a ref.
  const [prevUser, setPrevUser] = useState(user)
  const [redirectTarget, setRedirectTarget] = useState(null)
  if (user !== prevUser) {
    setPrevUser(user)
    if (!user && redirectTarget === null) {
      setRedirectTarget(sessionStorage.getItem(POST_LOGOUT_REDIRECT_KEY) || ROUTES.LOGIN)
    }
  }

  // The actual clear is a real side effect, so it belongs in an effect, not
  // in the render body above.
  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem(POST_LOGOUT_REDIRECT_KEY)
    }
  }, [user])

  if (loading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-bg)',
      }}>
        <div style={{
          width: 32,
          height: 32,
          border: '3px solid var(--color-border)',
          borderTopColor: 'var(--color-blue)',
          borderRadius: '50%',
          animation: 'spin 0.7s linear infinite',
        }} />
      </div>
    )
  }

  if (!user) {
    return <Navigate to={redirectTarget ?? ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return children
}
